var map = {
	"./angpao.webp": 2302,
	"./bonus.webp": 2303,
	"./gpi-rebate-m.webp": 2304,
	"./gpi-rebate.webp": 2305,
	"./hublot-watch-2018.webp": 2306,
	"./hublot-watch-2022.webp": 2307,
	"./iphone-13-pro-max.webp": 2308,
	"./iphone-14-pro-max.webp": 2309,
	"./login-to-m.webp": 2310,
	"./login-to.webp": 2311,
	"./mb.webp": 2312,
	"./mg-rebate-m.webp": 2313,
	"./mg-rebate.webp": 2314,
	"./np.webp": 2315,
	"./pointer.webp": 2316,
	"./pp-rebate-m.webp": 2317,
	"./pp-rebate.webp": 2318,
	"./sadface.webp": 2319,
	"./wallet-m.webp": 2320,
	"./wallet.webp": 2321,
	"./wheel-b.webp": 2322,
	"./wheel-btn.webp": 2323,
	"./wheel-indon-b.webp": 2324,
	"./wheel-indon.webp": 2325,
	"./wheel.webp": 2326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 929;